/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Simple_Oto_Faq_Q2Inputs */

const en_simple_oto_faq_q2 = /** @type {(inputs: Simple_Oto_Faq_Q2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`How long until I can use it?`)
};

const id_simple_oto_faq_q2 = /** @type {(inputs: Simple_Oto_Faq_Q2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Berapa lama sampai bisa dipakai?`)
};

/**
* | output |
* | --- |
* | "How long until I can use it?" |
*
* @param {Simple_Oto_Faq_Q2Inputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const simple_oto_faq_q2 = /** @type {((inputs?: Simple_Oto_Faq_Q2Inputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Simple_Oto_Faq_Q2Inputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_simple_oto_faq_q2(inputs)
	return en_simple_oto_faq_q2(inputs)
});